import { useEffect } from "react";

const VhScript = () => {
  useEffect(() => {
    let vh = 0.01 * window.innerHeight;
    document.documentElement.style.setProperty("--vh", `${vh}px`),
      window.addEventListener("resize", () => {
        let vh = 0.01 * window.innerHeight;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      });
  }, []);

  return null;
};

export default VhScript;
